import axios from './axiosInstance'
import constants from '../constants'
import { getCallApiBase, getCallApiHeaders } from './chatApiClient'

export default function init() {
  console.log('call logs init')
}

export async function get(app, callsHost, type = 'calls', startRange, endRange, filters = {}, pageNo = 1) {
  let URL = `${getCallApiBase(app, callsHost)}/${type}`

  const params = new URLSearchParams()
  params.append('perPage', '10')
  params.append('page', String(pageNo))
  if (startRange) params.append('startedAt', startRange)
  if (endRange) params.append('endedAt', endRange)

  // Append multi-select filter params when non-empty
  if (filters.mode) {
    params.append('mode', filters.mode)
  }
  if (filters.status) {
    params.append('status', filters.status)
  }
  if (filters.hasRecording) {
    params.append('hasRecording', filters.hasRecording)
  }
  if (filters.receiverType) {
    params.append('receiverType', filters.receiverType)
  }

  // Append numeric filters using bracket notation with operator validation
  const VALID_OPS = ['gt', 'lt', 'eq', 'gte', 'lte']
  if (filters.duration && VALID_OPS.includes(filters.duration.operator)) {
    params.append(`duration[${filters.duration.operator}]`, filters.duration.value)
  }
  if (filters.totalParticipants && VALID_OPS.includes(filters.totalParticipants.operator)) {
    params.append(`totalParticipants[${filters.totalParticipants.operator}]`, filters.totalParticipants.value)
  }
  if (filters.voiceMinutes && VALID_OPS.includes(filters.voiceMinutes.operator)) {
    params.append(`voiceMinutes[${filters.voiceMinutes.operator}]`, filters.voiceMinutes.value)
  }
  if (filters.videoMinutes && VALID_OPS.includes(filters.videoMinutes.operator)) {
    params.append(`videoMinutes[${filters.videoMinutes.operator}]`, filters.videoMinutes.value)
  }

  const queryString = params.toString()
  if (queryString) URL += `?${queryString}`

  return axios
    .get(`${URL}`, {
      headers: getCallApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}


export async function getParticipants(
  app,
  appSettings,
  type,
  sessionID,
  beginningTimestamp,
  endingTimestamp,
) {
  let URL = constants.isLiveEnv ? 'https://' : 'http://'
  URL = `${URL}${appSettings}/v1/${type}/sessions/${sessionID}/participants?beginningTimestamp=${beginningTimestamp}&endingTimestamp=${endingTimestamp}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = false
      if (error.response !== undefined && error.response.data !== undefined)
        err = error.response.data

      return err
    })
}

export async function downloadRecording(fileUrl, fileName) {
  return axios({
    method: 'get',
    url: fileUrl,
    responseType: 'arraybuffer',
  })
    .then(response => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/octet-stream' }),
      )
      link.download = `${fileName}.mp4`

      document.body.appendChild(link)

      link.click()
      setTimeout(function fn() {
        window.URL.revokeObjectURL(link)
      }, 200)
      return response.data
    })
    .catch(() => {
      const err = { error: 'You call recording cannot be downloaded. Please try again.' }
      return err
    })
}

export async function getByID(app, callsHost, sessionID) {
  const URL = `${getCallApiBase(app, callsHost)}/calls/${sessionID}`
  return axios
    .get(`${URL}`, {
      headers: getCallApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
